module.exports = __webpack_public_path__ + "img/shili3.b11f28d7.png";